export const AgreementTypes = {
  PARKING_LOT: 'Autopaikka',
};
